module.exports = __webpack_public_path__ + "i18n/nl.b2d310ce1fdfc9a57a7cb27b20fe03d6.json";